import { getUserTimeZone } from "@core/Helpers/js-date-transformations";
import { ICrmUserInfo } from "@core/Models/autogenerated/user.models";
import { QueryVars } from "@core/Utils/MongoQueryParser";

export function createQueryVars(userInfo: ICrmUserInfo | null): QueryVars {
    return new QueryVars(getUserTimeZone(), userInfo?.login);
}